/* eslint-disable @next/next/no-img-element */
import Link from "next/link";
import { useEffect, useState } from "react";
import MainMenu from "../MainMenu";
import MobileMenu from "../MobileMenu";

const Header1 = () => {
  const [navbar, setNavbar] = useState(false);

  const changeBackground = () => {
    if (window.scrollY >= 10) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", changeBackground);
  }, []);

  return (
    <>
      {" "}
      {/* <header className={`header ${navbar ? "is-sticky bg-white" : ""}`} */}
      <header className={`header ${navbar ? "" : ""}`}
        style={{
          backgroundImage: `url("/img/backgrounds/header-bckgrd-image-2.png")`, // Remplacez par le chemin de votre image
          backgroundSize: "cover",
          backgroundPosition: "center",
          // backgroundColor: 'red',
          height: '300px',
          paddingBottom: '130px'
          // opacity: navbar ? 0.9 : 0.5
        }}>
        <div className="header__container header__container-1500 mx-auto px-30 sm:px-20">
          <div className="row justify-between items-center">
            <div className="col-auto">
              <div className="d-flex items-center">
                <Link href="/" className="header-logo mr-50">
                <img src="/img/general/logo-memorial-joola.png" alt="logo memorial le joola" />
                </Link>
                {/* End logo */}

                <div className="header-menu">
                  <div className="header-menu__content">
                    <MainMenu style="text-dark-1" />
                  </div>
                </div>
                {/* End header-menu */}
              </div>
              {/* End d-flex */}
            </div>
            {/* End col */}

            <div className="col-auto">
              <div className="d-flex items-center">
                {/* ajouter photo bateau joola */}
                <div className="d-flex items-center is-menu-opened-hide md:d-none">
                  
                <img
                style={{width: '60%'}}
                  src="/img/masthead/10/bateau-le-joola-2.png"
                  alt="image"
                  className="rounded-16 menu-item-has-children menu-boat"
                />

                  {/* <Link
                    href="/others-pages/login"
                    className="button px-30 fw-400 text-14 -blue-1 bg-mem-orange h-50 text-white"
                  >
                    Acheter Ticket
                  </Link>*/}
                </div> 
                {/* End d-flex */}

                {/* Start mobile menu icon */}
                <div className="d-none xl:d-flex x-gap-20 items-center pl-30 text-dark-1">
                  {/* <div>
                    <Link
                      href="/others-pages/login"
                      className="d-flex items-center icon-user text-inherit text-22"
                    />
                  </div> */}
                  <div>
                    <button
                      className="d-flex items-center icon-menu text-inherit text-20"
                      data-bs-toggle="offcanvas"
                      aria-controls="mobile-sidebar_menu"
                      data-bs-target="#mobile-sidebar_menu"
                    />

                    <div
                      className="offcanvas offcanvas-start  mobile_menu-contnet"
                      tabIndex="-1"
                      id="mobile-sidebar_menu"
                      aria-labelledby="offcanvasMenuLabel"
                      data-bs-scroll="true"
                    >
                      <MobileMenu />
                      {/* End MobileMenu */}
                    </div>
                  </div>
                </div>
                {/* End mobile menu icon */}
              </div>
              {/* End d-flex */}
            </div>
            {/* End col-auto */}
          </div>
          {/* End .row */}
        </div>
        {/* End header_container */}
      </header>
      {/* End header */}
    </>
  );
};

export default Header1;
